export default {"src":"/_next/static/media/hdyhau_selected_check.f4dd0dd7.svg","height":28,"width":28};